import React from 'react';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';

const DateRangePicker = ({ dateRange }) => {
    const maxDate = new Date();
    const onChange = (e) => {
      dateRange(e.text)
    };

    return (
        <div>
            <DateRangePickerComponent placeholder='Enter Date Range'
                max={maxDate}
                format="dd-MMM-yyyy"
                change={onChange}
            >
            </DateRangePickerComponent>
        </div>
    )
}

export default DateRangePicker